import Card from 'components/card';
import styles from './index.module.sass';
import iconArrow from 'assets/icon_cad_arrow.svg';
import Spin from 'components/spin';

const SelectCard = ({ cards, onClick }) => {
  return (
    <div className={styles['select-card']}>
      <div className={styles.title}>連結付款方式</div>
      <p>立即開始享受路邊停車自動繳的便利，停車場車牌辨識出場快速完成付款！</p>
      <div className={styles.subtitle}>綁定全國大利 PAY</div>
      {cards.length === 0 && (
        <div className={styles.loading}>
          <Spin />
        </div>
      )}
      {cards.map(card => {
        const text = card.type.includes('-D') ? '全國大利卡（綁定一般信用卡）' : '全國加油聯名卡';
        return (
          <Card className={styles.card} key={card.type} onClick={() => onClick(card)}>
            {text}
            <img src={iconArrow} alt="arrow" className={styles.arrow} />
          </Card>
        );
      })}
    </div>
  );
};

export default SelectCard;
